var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPencil(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.126 1.74857C18.6456 1.74857 18.1645 1.92924 17.7996 2.29422L16.8035 3.29032L20.4766 7.4293L21.7057 6.20028C22.4356 5.47035 22.4356 4.27809 21.7057 3.54816L20.4517 2.29422C20.0868 1.92924 19.6065 1.74857 19.126 1.74857ZM16.2724 3.82135L3.77049 16.3233L5.43971 18.0284L17.8596 5.60922L16.2724 3.82135ZM18.3584 6.17247L5.9656 18.566L7.63483 20.2711L19.9456 7.96034L18.3584 6.17247ZM3.32737 16.9429L2.79928 18.4225L5.62063 21.1852L6.99834 20.6937L3.32737 16.9429ZM2.52169 19.2003L1.52264 21.9982C1.49889 22.065 1.49457 22.1372 1.51017 22.2064C1.52578 22.2756 1.56068 22.3389 1.61083 22.389C1.66097 22.4392 1.7243 22.4741 1.79348 22.4897C1.86266 22.5053 1.93484 22.501 2.00166 22.4772L4.83545 21.4657L2.52169 19.2003Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.da44aba48d626f778896727690fb76bf.svg";
export { ForwardRef as ReactComponent };